<template>
  <!-- 如果是不是隐藏 -->
  <div v-if="!item.hidden">
    <!-- 如果只有一个子节点或无子节点 -->
    <template v-if="hasOneShowingChild(item.children,item)">
      <app-link :to="item.url || ''">
        <el-menu-item :index="item.url" :class="{'submenu-title-noDropdown':!isNest}" @click="onClick(item)">
          <span class="svg-container">
            <svg-icon icon-class="file" />
          </span>
          <item :icon="item.icon" :title="item.name" />
        </el-menu-item>
      </app-link>
    </template>

    <!-- 如果有多个子节点  -->
    <el-submenu v-else ref="subMenu" :index="item.code" popper-append-to-body>
      <template slot="title">
        <span class="svg-container">
          <svg-icon icon-class="folder" />
        </span>
        <item :icon="item.icon" :title="item.name" />
      </template>
      <sidebar-item
        v-for="child in item.children"
        :key="child.code"
        :is-nest="true"
        :item="child"
        :base-path="child.url"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
// 方法，判断地址是否为外部链接
import { isExternal } from '@/utils/validate'
import Item from './Item'
import AppLink from './Link'
import FixiOSBug from './FixiOSBug'

export default {
  name: 'SidebarItem',
  components: { Item, AppLink },
  mixins: [FixiOSBug],
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  created() {

  },
  methods: {
    // 判断是否有需要显示的子节点
    hasOneShowingChild(children = [], parent) {
      //
      if (children.length === 0) {
        return true
      } else {
        return false
      }
    },
    // 解析路径
    resolvePath(routePath) {
      // 如果是是外部路径，返回
      if (isExternal(routePath)) {
        return routePath
      }
      // 如果basePath是外部路径返回basePath
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      return path.resolve(this.basePath, routePath)
    },
    onClick(item) {
      // this.$store.dispatch('user/setMenu', item).then(function() {
      // }).catch(() => {
      //   this.loading = false
      // })
      //
      // sjh
      // this.$store.dispatch('tagsView/changeUrlCode', item.code)
      this.$store.dispatch('tagsView/addView', item).then(function() {
      }).catch(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" >
.el-menu-item, .el-submenu__title {
  height: 40px;
  line-height: 40px;
}

.el-submenu .el-menu-item{
  height: 40px;
  line-height: 40px;
}
.router-link-active{

    color: #5697F1;
    background-color: none;
}
.el-menu-item:focus,
.el-menu-item:hover {
  background-color: none;
}
</style>
